import { useQuery } from "@tanstack/react-query";
import { getAllContracts, getContractById } from "@/api";
import { ContractRow, ContractDetail } from "@types";
import { useInfiniteList } from "@hooks";

export const CONTRACTS_QK = ["contracts"] as const;

export function useAllContracts(
  locationId?: string,
  origin?: string,
  status?: string,
) {
  return useInfiniteList<ContractRow>({
    queryKey: [...CONTRACTS_QK, locationId ?? "all", origin ?? "all", status ?? "all"],
    fetchFn: async (page) => {
      const res = await getAllContracts(page, locationId, origin, status);
      return res.data;
    },
  });
}

export function useContractDetail(contractId: string | null) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["contract-detail", contractId],
    queryFn: async () => {
      const res = await getContractById(contractId!);
      return res.data.data;
    },
    enabled: !!contractId,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  return {
    contract: data as ContractDetail | undefined,
    loading: isLoading,
    error,
  };
}
